import styled from 'styled-components';

import { SymbolSelector as RawSymbolSelector } from '@src/components/SymbolSelector';
import { Box } from '@talos/kyoko';

export const SymbolSelector = styled(RawSymbolSelector)`
  flex: 1;
  width: 154px;
`;

export const MarketAccountsWrapper = styled(Box)`
  scrollbar-gutter: stable both-edges;
`;
MarketAccountsWrapper.defaultProps = {
  overflow: 'auto',
  flex: '1 1 auto',
  mx: '-spacing16',
  px: 'spacing8',
};

export const MarketsWrapper = styled.div`
  padding: 0 ${({ theme }) => theme.spacing8}px;
  scrollbar-gutter: stable both-edges;
  overflow-y: auto;
  height: 100%;
`;
